export default "__VITE_ASSET__DvN4kFEm__"